<template>
  <div class="content">
    <div class="container ad_main">
      <h3 class="mb10">{{ $route.query.id ? $t('common.editAdsense') : $t('common.addAdsense') }}</h3>
      <el-form :model="formData" ref="formRef" :rules="formRules" label-position="left" label-width="120px">
        <div>
          <!-- 添加广告位 -->
          <div class="form_pad">
              <el-form-item :label="$t('table.application')" prop="application_id">
                <el-select 
                  v-model="formData.application_id" 
                  filterable 
                  :placeholder="$t('common.selectApp')"
                  class="w400"
                >
                  <el-option
                    v-for="(item,index) in appList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('table.adsenseName')" prop="name">
                <el-input v-model="formData.name" class="w400" :placeholder="$t('required.adName')"></el-input>
              </el-form-item>
              <el-form-item label="GPID" prop="gpid">
                <el-input v-model="formData.gpid" class="w400" :placeholder="$t('common.enter') + 'GPID'"></el-input>
              </el-form-item>
              <el-form-item :label="$t('table.coMode')" prop="co_mode">
                <el-select 
                  v-model="formData.co_mode" 
                  filterable 
                  :placeholder="$t('common.selectMode')"
                  class="w400"
                  @change="modeChange"
                  >
                    <el-option
                    v-for="(item,index) in $com.abroadList.modeList"
                    :key="item.id"
                    :label="$i18n.locale == 'zh'?item.name : item.en_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="formData.co_mode == 1" :label="$t('table.pdPrice')" prop="min_price">
                <el-input v-model="formData.min_price" class="w400" @blur="formatMinPrice">
                </el-input>
                <span> {{$t('common.meiyuan')}}/cpm</span>
              </el-form-item>
          </div>
        </div>
        <!-- 广告类型 -->
        <div>
          <h4 class="mtb">{{$t('sdk.flowType')}}</h4>
          <div class="flow">
            <el-card 
              class="flow_item" 
              :class="formData.flow_type == item.id? 'flow_item_active':''" 
              v-for="item in flowTypeList"
              v-show="editMode ? item.id === formData.flow_type : (item.show && item.id !== 1)"
              @click.native="flowTypeChange(item)"
            >
              <h4>{{$i18n.locale == 'zh'?item.name : item.en_name}}</h4>
              <p>{{$i18n.locale == 'zh'?item.introduce : item.in_en_name}}</p>
            </el-card>
          </div>
        </div>

        <!-- 样式配置 -->
        <h4 class="mtb">{{$t('sdk.styleConfig')}}</h4>
        <el-form-item :label="$t('sdk.rendeMode')">
          <el-radio-group v-model="formData.rendering_type">
            <el-radio-button :label="1">{{$t('sdk.platformRender')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" @click="onSave" :disabled="isDisabled">{{$t('save')}}</el-button>
        <el-button @click="handleCancel">{{$t('cancel')}}</el-button>
      </div>
    </div>
    <!-- 右侧广告位样式展示 -->
    <div class="container flow_style">
      <h3 class="mgb20">{{$t('sdk.adsenseShow')}}-{{ adName }}</h3>
      <el-tabs v-model="activeName">
        <el-tab-pane 
          v-for="item in styleList" 
          :label="$i18n.locale == 'zh'?item.name : item.en_name" 
          :name="item.id">
          <div class="style_item">
            <el-image
              style="width: 350px; height: 630px"
              :src="getImgSrc(item.img)"
              fit="contain"
            ></el-image>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isDisabled: false, // 防止重复点击
      timer: null,
      formData: {
        id: 0,
        application_id: null,
        name: "",
        co_mode: null,
        gpid: "",
        min_price: null,
        flow_type: 4,
        template_id: [],
        rendering_type: 1,
      },
      appList: [],
      templateList: [],
      sizeList: [],
      styleList: [],
      flowTypeList: [...this.$com.abroadList.flowTypeOpenAd, ...this.$com.abroadList.flowTypeList,],
      activeName: "1",
      adName: "",
      formRules: {
        application_id: [
          { required: true, message: this.$t('common.selectApp'), trigger: "change"},
        ],
        name: [
          { required: true, message: this.$t('required.adName'), trigger: "blur"},
        ],
        co_mode: [
          { required: true, message: this.$t('common.selectMode'), trigger: "change"},
        ],
        template_id: [
          { required: true, message: this.$t('required.template'), trigger: "change"},
        ],
        min_price: [
          { required: true, message: this.$t('required.pdPrice'), trigger: "blur"},
          { 
            validator: (rule, value, callback) => {
              const num = parseFloat(value);
              if (isNaN((num))) {
                callback(new Error(this.$t('required.pdPriceNumber')));
                return;
              }
              if (num <= 0 || num > 999.99) {
                callback(new Error(this.$t('required.pdPriceRange')));
                return;
              }
              const decimalPart = String(num).split('.')[1] || '';
              if (decimalPart.length > 2) {
                callback(new Error(this.$t('required.pdPriceFloat')));
                return;
              }
              callback();
            },
            trigger: ["change", "blur"]
          }
        ],
      },
    }
  },
  computed: {
    editMode() {
      return this.$route.query.id != null
    }
  },
  created() {
    if(this.$route.query.id) {
      this.getAdDetail()
    } else {
      let defaultFlow = this.flowTypeList.find(item => item.id === 4) || this.flowTypeList[0];
      this.flowTypeChange(defaultFlow);
    }
  },
  mounted() {
    this.getAPPList()
  },
  beforeDestroy() {
    if(this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    getAPPList() {
      let params = {
        page: 1,
        page_size: 1000,
        // status: 1,
      };
      this.__postData('sspAppList', params, (res) => {
        if(res.list){
          this.appList = res.list
        }
      })
    },
    getImgSrc(img) {
        return require('@/assets/img/flow_style/' + img)
    },
    // 切换渲染方式
    renderChange() {
      this.styleData.style = []
      this.styleData.elements = []
    },
    // 获取广告详情
    getAdDetail() {
      let params = {id: this.$route.query.id}
      this.__getData('getAdDetail', params, (res) => {
        for(var key in res) {
					if(key in this.formData) {
						this.formData[key] =	JSON.parse(JSON.stringify(res[key]))
					}
				}
        // 展示对应的广告类型
        let flow_type = (this.flowTypeList.find(item => item.id == this.formData.flow_type))
        this.updateFlowData(flow_type)
      })
    },
    // 初始化或者更改广告类型重置模版和广告位展示
    updateFlowData(item) {
      this.formData.flow_type = item.id;
      this.templateList = item.abroad_template;
      this.adName = this.$i18n.locale == 'zh' ? item.name : item.en_name;
      this.styleList = item.style && item.style.length > 0 ? item.style : [];
      this.activeName = this.styleList.length > 0 ? this.styleList[0].id : '';
    },

    flowTypeChange(item) {
      this.updateFlowData(item);
      // 切换广告类型默认选中其对应的模版
      this.formData.template_id = item.abroad_template.map(t => t.template_id);
      this.sizeList = item.size;
    },
    // 切换合作模式，清空Flat-CPM
    modeChange(val) {
      if(val !== 1) {
        this.formData.min_price = null
      }
    },
    onSave() {
      this.isDisabled = true
      this.timer = setTimeout(() => {
        this.isDisabled = false
        clearTimeout(this.timer)
      }, 1500);
      let that = this
      function validateForm1() {
        return new Promise((resolve, reject) => {
          // 表单校验逻辑...
          that.$refs["formRef"].validate((valid) => {
            if(valid) {
              resolve();
            } else {
              reject();
            }
          })
        });
      }
      
      // 首先执行第一个表单校验
      validateForm1()
        // 如果第一个表单校验通过，那么执行第二个表单校验
        .then(() => {
          console.log('所有表单都通过校验，并且数据已经保存')
          let params = Object.assign({}, this.formData, this.styleData, this.abilityData);
          this.__postData('adAddOrUpdate', params, (res) => {
            clearTimeout(this.timer)
            this.timer = null
            if(res.code == 1) {
              this.$message.error(res.msg);
            } else {
              this.$message.success(this.$t('message.successSava'));
              this.handleCancel()
            }
            this.isDisabled = false
          })
        })
        .catch((err) => {
          this.isDisabled = false;
          clearTimeout(this.timer);
          this.timer = null;
          this.$message.error(this.$t('message.errorComplete'));
          console.log('有表单未通过校验，保存操作被终止', err)
        });
    },
    handleCancel() {
      this.$router.back()
    },
    formatMinPrice() {
      const value = this.formData.min_price
      if (value === '' || value === null) return
      
      const num = parseFloat(value)
      if (!isNaN(num)) {
        this.formData.min_price = num.toFixed(2)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.content {
  height: auto;
  display: flex;
  justify-content: flex-start;
  .ad_main {
    flex: 1;
  }
  .flow_style {
    margin-left: 10px;
    width: 350px;
    .style_item {
      width: 100%;
      text-align: center;
      margin-top: 10px;
    }
  }
}
/deep/.el-tabs {
  .el-tabs__nav {
    width: 100%;
    text-align: center;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      height: 3px;
    }
  }
  .el-tabs__item.is-active, .el-tabs__item:hover {
    color: #3361FF;
  }
  .el-tabs__active-bar {
    background-color: transparent;
  }
}
.form_pad {
  padding: 0 30px;
}
.w400 {
  width: 400px;
}
.mtb {
  margin: 20px 0 10px 0;
}
.flow {
  display: flex;
  flex-wrap: wrap;
  .flow_item {
    width: 32%;
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
    margin-right: 5px;
    cursor: pointer;
    p {
      font-size: 12px;
    }
  }
}
.flow_item_active {
  border: 1px solid #3361FF;
  color: #3361FF;
}
.footer {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}


</style>